import "core-js/modules/es.number.to-fixed.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/icons/Rectangle_47.jpg';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4cda9187"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "completeOrderComponent",
  class: "order-confirmed-wrapper h-100",
  "data-cy": "completed-order-step"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    class: "order-image",
    src: _imports_0,
    alt: "order"
  }, null, -1);
});

var _hoisted_3 = {
  class: "image-text"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("br", null, null, -1);
});

var _hoisted_5 = {
  class: "image-second-text"
};
var _hoisted_6 = {
  class: "complete-order-info"
};
var _hoisted_7 = {
  class: "order-title"
};
var _hoisted_8 = {
  id: "orderValue",
  class: "amount-paid"
};
var _hoisted_9 = {
  class: "complete-order-info"
};
var _hoisted_10 = {
  class: "order-title"
};
var _hoisted_11 = {
  id: "paidValue",
  class: "amount-paid"
};
var _hoisted_12 = {
  class: "complete-order-info"
};
var _hoisted_13 = {
  class: "order-title"
};
var _hoisted_14 = {
  id: "changeValue",
  class: "amount-paid"
};
var _hoisted_15 = {
  class: "d-flex fl-col fl-j-c"
};
var _hoisted_16 = {
  class: "reference"
};
var _hoisted_17 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "center"
  }
};
var _hoisted_18 = {
  class: "buttons-wrapper",
  style: {
    "width": "fit-content",
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "center",
    "align-items": "center"
  }
};
var _hoisted_19 = {
  key: 0,
  style: {
    "text-align": "left"
  },
  class: "w-100 pb-5"
};
var _hoisted_20 = {
  key: 0
};
var _hoisted_21 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-between"
  },
  class: "buttons-panel"
};
var _hoisted_22 = {
  style: {
    "margin": "5px"
  }
};
var _hoisted_23 = {
  class: "icon-wrapper d-flex fl-col fl-a-s fl-s-a"
};
var _hoisted_24 = {
  class: "button-text"
};
var _hoisted_25 = {
  style: {
    "margin": "5px"
  },
  class: "d-flex fl-j-c"
};
var _hoisted_26 = {
  class: "icon-wrapper d-flex fl-col fl-a-s fl-s-a"
};
var _hoisted_27 = {
  class: "button-text"
};
var _hoisted_28 = {
  key: 0,
  style: {
    "margin": "5px"
  },
  class: "d-flex fl-j-c"
};
var _hoisted_29 = {
  class: "icon-wrapper d-flex fl-col fl-a-s fl-s-a"
};
var _hoisted_30 = {
  style: {
    "margin": "5px"
  }
};
var _hoisted_31 = {
  class: "icon-wrapper d-flex fl-col fl-a-s fl-s-a"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_col = _resolveComponent("el-col");

  var _component_el_row = _resolveComponent("el-row");

  var _component_SvgIcon = _resolveComponent("SvgIcon");

  var _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "info-panel",
    justify: "space-evenly",
    gutter: 5
  }, {
    default: _withCtx(function () {
      var _ctx$selectedBooking, _ctx$selectedBooking2;

      return [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", null, [_hoisted_2, _createElementVNode("p", _hoisted_3, [_createTextVNode(_toDisplayString(_ctx.$t("completeorder.order-completed")) + " ", 1), _hoisted_4, _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("completeorder.summary")), 1)])])];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 5
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_row, {
            justify: "center"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("completeorder.order-total")), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_row, {
            justify: "center"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("p", _hoisted_8, _toDisplayString((_ctx.bookingTotal / 100).toFixed(2)), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_row, {
            justify: "center"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("p", null, _toDisplayString(_ctx.payingCurrency), 1)];
            }),
            _: 1
          })])];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 5
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_row, {
            justify: "center"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("completeorder.amount-paid")), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_row, {
            justify: "center"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("p", _hoisted_11, _toDisplayString((_ctx.amountPaid / 100).toFixed(2)), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_row, {
            justify: "center"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("p", null, _toDisplayString(_ctx.payingCurrency), 1)];
            }),
            _: 1
          })])];
        }),
        _: 1
      }), !((_ctx$selectedBooking = _ctx.selectedBooking) !== null && _ctx$selectedBooking !== void 0 && _ctx$selectedBooking.type) || ((_ctx$selectedBooking2 = _ctx.selectedBooking) === null || _ctx$selectedBooking2 === void 0 ? void 0 : _ctx$selectedBooking2.type) !== _ctx.BookingType.Invoice ? (_openBlock(), _createBlock(_component_el_col, {
        key: 0,
        span: 5
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_row, {
            justify: "center"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("completeorder.change-due")), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_row, {
            justify: "center"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("p", _hoisted_14, _toDisplayString(Math.abs(_ctx.changeDue / 100).toFixed(2)), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_row, {
            justify: "center"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("p", null, _toDisplayString(_ctx.payingCurrency), 1)];
            }),
            _: 1
          })])];
        }),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_el_col, {
        span: 23
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_row, {
            class: "edit-order-section"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_col, {
                span: 19,
                class: "order-reference"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_15, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("completeorder.order-reference")), 1), _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.orderReference), 1)])];
                }),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 5,
                class: "edit-order-button"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", {
                    id: "editOrderButton",
                    class: "d-flex fl-col fl-j-c fl-a-c",
                    onClick: _cache[0] || (_cache[0] = function ($event) {
                      return _ctx.editOrder();
                    }),
                    "data-cy": "edit-order-button"
                  }, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("completeorder.edit-order")), 1)])];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_ctx.requireTeams ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("h2", null, _toDisplayString(_ctx.$t("completeorder.teams")), 1), _ctx.teamsStatus === _ctx.BookingTeamsStatus.Completed ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createTextVNode(_toDisplayString(_ctx.$t("teams.successfully-assigned")) + " ", 1), _createElementVNode("span", {
    style: {
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    onClick: _cache[1] || (_cache[1] = _withModifiers( //@ts-ignore
    function () {
      return _ctx.showTeamsView && _ctx.showTeamsView.apply(_ctx, arguments);
    }, ["stop"]))
  }, _toDisplayString(_ctx.$t("button.click-to-edit")), 1)])) : _createCommentVNode("", true), _ctx.teamsStatus === _ctx.BookingTeamsStatus.NotStarted ? (_openBlock(), _createElementBlock("span", {
    key: 1,
    style: {
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    onClick: _cache[2] || (_cache[2] = _withModifiers( //@ts-ignore
    function () {
      return _ctx.showTeamsView && _ctx.showTeamsView.apply(_ctx, arguments);
    }, ["stop"]))
  }, _toDisplayString(_ctx.$t("completeorder.add-teams")), 1)) : _createCommentVNode("", true), _ctx.teamsStatus === _ctx.BookingTeamsStatus.InProgress ? (_openBlock(), _createElementBlock("span", {
    key: 2,
    style: {
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    onClick: _cache[3] || (_cache[3] = _withModifiers( //@ts-ignore
    function () {
      return _ctx.showTeamsView && _ctx.showTeamsView.apply(_ctx, arguments);
    }, ["stop"]))
  }, _toDisplayString(_ctx.$t("completeorder.complete-teams")), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createVNode(_component_el_button, {
    class: "finish-order-buttons print-button",
    "data-cy": "open-popup-print-ticket-and-receipt-button",
    onClick: _withModifiers(_ctx.openPrintTicketsAndReceiptModal, ["stop"])
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_23, [_createVNode(_component_SvgIcon, {
        iconContent: _ctx.printerIconContent,
        iconAlt: _ctx.printerIconAlt,
        iconStyle: _ctx.iconStyle
      }, null, 8, ["iconContent", "iconAlt", "iconStyle"]), _createElementVNode("span", null, _toDisplayString("".concat(_ctx.$t("completeorder.print"))), 1), _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.printButtonText), 1)])];
    }),
    _: 1
  }, 8, ["onClick"])]), _createElementVNode("div", _hoisted_25, [_createVNode(_component_el_button, {
    class: "finish-order-buttons email-button",
    onClick: _withModifiers(_ctx.sendEmail, ["stop"])
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_26, [_createVNode(_component_SvgIcon, {
        iconContent: _ctx.emailIconContent,
        iconAlt: _ctx.emailIconAlt,
        iconStyle: _ctx.iconStyle
      }, null, 8, ["iconContent", "iconAlt", "iconStyle"]), _createElementVNode("span", null, _toDisplayString("".concat(_ctx.$t("completeorder.email"))), 1), _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$t("completeorder.tickets-receipt") + " & " + _ctx.$t("button.invoice")), 1)])];
    }),
    _: 1
  }, 8, ["onClick"])]), _ctx.showScanBtn ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createVNode(_component_el_button, {
    class: "finish-order-buttons scan-button",
    onClick: _withModifiers(_ctx.throttleScanning, ["stop"])
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_29, [_createVNode(_component_SvgIcon, {
        iconContent: _ctx.scannerIconContent,
        iconAlt: _ctx.scannerIconAlt,
        iconStyle: _ctx.iconStyle
      }, null, 8, ["iconContent", "iconAlt", "iconStyle"]), _createElementVNode("span", null, _toDisplayString("".concat(_ctx.$t("completeorder.scan"))), 1), _createTextVNode(" " + _toDisplayString(_ctx.$t("completeorder.tickets")), 1)])];
    }),
    _: 1
  }, 8, ["onClick"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_30, [_createVNode(_component_el_button, {
    class: "finish-order-buttons print-button",
    onClick: _withModifiers(_ctx.showDownloadTicketsModal, ["stop"])
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_31, [_createVNode(_component_SvgIcon, {
        iconContent: _ctx.downloadIconContent,
        iconAlt: "download",
        iconStyle: _ctx.iconStyle
      }, null, 8, ["iconContent", "iconStyle"]), _createElementVNode("span", null, _toDisplayString("".concat(_ctx.$t("completeorder.download"))), 1), _createTextVNode(" " + _toDisplayString(_ctx.$t("completeorder.tickets") + " & " + _ctx.$t("button.invoice")), 1)])];
    }),
    _: 1
  }, 8, ["onClick"])])]), _createElementVNode("div", {
    class: "finishing-text",
    onClick: _cache[4] || (_cache[4] = //@ts-ignore
    function () {
      return _ctx.endBooking && _ctx.endBooking.apply(_ctx, arguments);
    }),
    "data-cy": "start-new-order-button"
  }, _toDisplayString(_ctx.$t("completeorder.new-sale")), 1)])])]);
}